// ABOUTME: The left-hand navigation of the AppBar: resolves the tenant's `appBar` layout over the
// ABOUTME: nav items the user may see and renders each entry as a button or a group dropdown.

import { Box } from '@ds/coolshop';
import { useMemo } from 'react';

import { useAppBarShape } from '../hooks/useAppBarShape';
import { useNavCandidates } from '../hooks/useNavCandidates';
import { resolveAppBarLayout } from '../utils/resolveAppBarLayout';
import { LinkTo } from './LinkTo';
import { NavGroupButton } from './NavGroupButton';

export const AppBarNav = () => {
    const candidates = useNavCandidates();
    const shape = useAppBarShape();

    const entries = useMemo(() => resolveAppBarLayout(candidates, shape), [candidates, shape]);

    return (
        <Box display="flex" gap={2} flexShrink={0} width="max-content">
            {entries.map(entry =>
                entry.kind === 'item' ? (
                    <LinkTo
                        key={entry.item.id}
                        dest={entry.item.dest}
                        icon={entry.item.icon}
                        activeIcon={entry.item.activeIcon}
                        label={entry.item.label}
                        disabled={entry.item.disabled}
                    />
                ) : (
                    <NavGroupButton
                        key={entry.id}
                        id={entry.id}
                        label={entry.label}
                        iconName={entry.iconName}
                        items={entry.items}
                    />
                ),
            )}
        </Box>
    );
};
